import { AUTH_TYPE } from '../../../Core.constants';
import { toUrlParams } from '../../helpers';
import { SENATOR_PROFILE_URL } from '../Session.constants';

export const getProfileUrl = ({
  authType,
  id,
  forwarder: { profile: url } = {},
  language,
  urlParams: { miraiId, type } = {},
  value,
} = {}) => {
  if (!id || !language || !url) return;

  return authType === AUTH_TYPE.SENATOR
    ? SENATOR_PROFILE_URL[language] || SENATOR_PROFILE_URL['en']
    : `${url}${toUrlParams({
        idtokenprovider: id,
        lang: language,
        miraiId,
        context: value,
        type,
      })}`;
};
